export default function RequestsController(AccountService, LKConfig) {
    var ctrl = this;

    ctrl.hitsList = LKConfig.hitsList;
    ctrl.maxSize = LKConfig.maxSize;
    ctrl.q = {};
    ctrl.q.hits = LKConfig.hitsList[1];
    ctrl.q.current = 1;

    ctrl.pageChanged = function() {
        var params = {};
        params.cat = 'userorders';
        params.startRecord = (ctrl.q.current-1)*ctrl.q.hits.value + 1;
        params.maximumRecords = ctrl.q.hits.value;
        AccountService.get(params).$promise.then(function(response) {
            ctrl.response = response;
        }, function(err) {
            ctrl.error = err.message | err;
        });
    };

    ctrl.firstPage = function() {
        ctrl.q.current = 1;
        ctrl.pageChanged();
    };

    ctrl.$onInit = function() {
        ctrl.firstPage();
    }

    /*ctrl.selectedItem = function(item) {
        console.log('selectedItem()', item);
        ctrl.itemsPerPage = 1;
        ctrl.q.current = item.recordPosition;
        ctrl.pageChanged();
    };*/
}
RequestsController.$inject = ['AccountService', 'LKConfig'];
